import React, { FC } from 'react';

import { StylableComponent, stylePropType } from '@adsk/alloy-react-theme';

type LineProps = StylableComponent<HTMLSpanElement>;

const Line: FC<LineProps> = ({ style, ...props }) => (
  <span
    {...props}
    css={[
      {
        display: 'block',
        margin: '10px 0 4px',
      },
      style,
    ]}
  />
);

Line.displayName = 'Line';

Line.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
};

export default Line;
